import { render, staticRenderFns } from "./SearchProductsCard.vue?vue&type=template&id=677571eb&"
import script from "./SearchProductsCard.vue?vue&type=script&lang=js&"
export * from "./SearchProductsCard.vue?vue&type=script&lang=js&"
import style0 from "./SearchProductsCard.vue?vue&type=style&index=0&id=677571eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports